import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import STSComponent from "../../STSComponent/STSComponent";
import './css/DropdownField.scss';

class DropdownField extends STSComponent {
  constructor (props) {
    super(props)
    this.updateFormData = this.updateFormData.bind(this)
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.value !== this.props.value ||
    JSON.stringify(nextProps.options) !== JSON.stringify(this.props.options) ||
    nextProps.placeholder !== this.props.placeholder ||
    nextProps.id !== this.props.id ||
    nextProps.className !== this.props.className
  }

  updateFormData = (val) => {
    const { location, id, toggleParameters, isExpanded, page } = this.props
    this.updateData(location, 'select', id, val.value)
    if(val !== 0 && !isExpanded && page ) {
      toggleParameters()
    }
  }

  render () {
    const { id, options, placeholder, className, value } = this.props
    const valueObject = options.find(elem => elem.value === value)
    return <Select
      className={`ordinary-drop-down ${className}`}
      classNamePrefix="select"
      name={id}
      value={valueObject || null}
      options={options}
      onChange={this.updateFormData}
      isSearchable={false}
      isClearable={false}
      placeholder={placeholder}
      maxMenuHeight={this.props.maxMenuHeight}
    />
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    value: PropTypes.any,
    id: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    toggleParameters: PropTypes.func,
    isExpanded: PropTypes.bool,
    page: PropTypes.string,
    maxMenuHeight: PropTypes.number,
  }
}

export default DropdownField



// WEBPACK FOOTER //
// ./src/components/FormComponents/DropdownField/DropdownField.js